import React, { useEffect, useState } from "react";
import { Container, InfoTag, AssociateInfo, Label } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { format } from "date-fns";
import {
  DatePicker,
  Button,
  Input,
  Tooltip,
  Spin,
  Pagination,
  Modal,
  Select,
} from "antd";
import {
  MdEdit,
  MdSearch,
  MdVisibility,
  MdClose,
  MdMail,
  MdPhone,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
  MdPeopleOutline,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import userPhoto from "../../../images/user.png";
import { useAuth } from "../../../hooks/AuthContext";
import { ViewInput, Message, InputTel } from "../../../GlobalStyles";
import { getValue } from "../../../services/functions";

const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;

const statuses = [
  "Pendente",
  "Oportunidade",
  "Abordagem",
  "Atendimento",
  "Qualificação",
  "Proposta Enviada",
  "Negociação",
  "Cliente Perdido",
  "Cliente Fechado",
];

export default function LeadsAssociado() {
  const { user } = useAuth();
  const locationState = useLocation();
  const [leads, setLeads] = useState([]);
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [page, setPage] = useState(0);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLead, setIsOpenLead] = useState(false);
  const [leadSelected, setLeadSelected] = useState({});

  const [id, setId] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [necessity, setNecessity] = useState("");
  const [employees, setEmployees] = useState("");
  const [location, setLocation] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [observation, setObservation] = useState("");

  useEffect(() => {
    if (locationState.state?.filterStatus) {
      setStatus(locationState.state.filterStatus);
    }
  }, [locationState.state]);

  useEffect(() => {
    loadLeads();
  }, [page, dateStart, dateEnd, status]);

  async function loadLeads() {
    setIsLoading(true);

    const params = {
      page: page,
    };
    if (dateStart && dateEnd) {
      params.dateStart = format(dateStart, "yyyy-MM-dd");
      params.dateEnd = format(dateEnd, "yyyy-MM-dd");
    }
    if (search) {
      params.search = search;
    }
    if (status) {
      params.status = status;
    }

    await api
      .get(`/leads/associate`, { params })
      .then((response) => {
        setLeads(response.data.leads || []);
        setLeadsTotal(response.data.total || 0);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });

    setIsLoading(false);
  }

  const getStatusClass = (status) => {
    console.log(status);
    const s = status || "";
    if (s.includes("Oportunidade")) return "oportunidade";
    if (s.includes("Atendimento") || s.includes("Abordagem"))
      return "atendimento";
    if (s.includes("Cliente Fechado")) return "fechado";
    if (s.includes("Cliente Perdido")) return "perdido";
    return "default";
  };

  async function handleSaveLead() {
    if (!name || !email || !phone_number) {
      return toast.warn(
        "Preencha todos os campos obrigatórios (Nome, E-mail e Telefone)",
      );
    }

    setIsLoadingModal(true);
    const data = {
      name,
      email,
      phone_number,
      necessity,
      employees,
      location,
      cnpj,
      observation,
      associate_id: user.id,
    };

    if (id) {
      await api
        .put(`/lead/master/${id}`, data)
        .then((response) => {
          setIsOpen(false);
          clearFields();
          loadLeads();
          toast.success("Lead editado com sucesso");
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    } else {
      await api
        .post(`/lead/master`, data)
        .then((response) => {
          setIsOpen(false);
          clearFields();
          loadLeads();
          toast.success("Lead cadastrado com sucesso");
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  function clearFields() {
    setId(null);
    setName("");
    setEmail("");
    setPhone_number("");
    setNecessity("");
    setEmployees("");
    setLocation("");
    setCnpj("");
    setObservation("");
  }

  return (
    <Container>
      <div className="header-actions">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 15,
            marginBottom: 25,
          }}
        >
          <h1 style={{ margin: 0 }}>Gestão de Leads</h1>
          <div
            style={{
              backgroundColor: "#00803722",
              color: "#008037",
              padding: "4px 12px",
              borderRadius: 50,
              fontSize: 13,
              fontWeight: "bold",
            }}
          >
            Total: {leadsTotal}
          </div>
        </div>
        <Button
          type="primary"
          size="large"
          style={{
            borderRadius: 50,
            backgroundColor: "#008037",
            borderColor: "#008037",
            height: 40,
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            marginBottom: 25,
          }}
          onClick={() => {
            clearFields();
            setIsOpen(true);
          }}
        >
          + Cadastrar Novo Lead
        </Button>
      </div>

      <div className="filters">
        <ViewInput style={{ width: 220 }}>
          <p>Filtrar por Status</p>
          <Select
            style={{ width: "100%" }}
            value={status}
            placeholder="Selecione o status"
            onChange={(value) => {
              setStatus(value);
              setPage(0);
            }}
          >
            <Option value="">Todos os Status</Option>
            {statuses.map((s) => (
              <Option key={s} value={s}>
                {s}
              </Option>
            ))}
          </Select>
        </ViewInput>

        <ViewInput style={{ width: 250 }}>
          <p>Buscar Lead</p>
          <Input
            placeholder="Nome, e-mail ou telefone"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={loadLeads}
            suffix={
              <MdSearch
                size={20}
                color="#999"
                style={{ cursor: "pointer" }}
                onClick={loadLeads}
              />
            }
          />
        </ViewInput>

        <ViewInput style={{ width: 280 }}>
          <p>Período de Cadastro</p>
          <RangePicker
            style={{ width: "100%" }}
            value={dateStart ? [dayjs(dateStart), dayjs(dateEnd)] : null}
            format={"DD/MM/YYYY"}
            placeholder={["data inicial", "data final"]}
            onChange={(dates) => {
              if (dates) {
                setDateStart(dates[0].toDate());
                setDateEnd(dates[1].toDate());
              } else {
                setDateStart(null);
                setDateEnd(null);
              }
              setPage(0);
            }}
          />
        </ViewInput>
      </div>

      {!isLoading ? (
        <>
          {leads.length > 0 ? (
            <div className="leads-list">
              {leads.map((lead) => (
                <div className="lead-card" key={lead.id}>
                  <div className="main-info">
                    <strong>{lead.name}</strong>
                    <span>{lead.email || "Sem e-mail cadastrado"}</span>
                  </div>

                  <div className="contact-info">
                    <MdPhone size={16} />
                    {lead.phone_number.replace(
                      /(\d{2})(\d{5})(\d{4})/,
                      "($1) $2-$3",
                    )}
                  </div>

                  <div className="date-info">
                    <label>Cadastro em</label>
                    {format(
                      new Date(lead.create_at || new Date()),
                      "dd/MM/yyyy",
                    )}
                  </div>

                  <div>
                    <div
                      className={`status-badge ${getStatusClass(lead?.leads?.[0]?.status || "Pendente")}`}
                    >
                      {lead?.leads?.[0]?.status || "Pendente"}
                    </div>
                  </div>

                  <div
                    className={`value-info ${getStatusClass(lead?.leads?.[0]?.status || "Pendente")}`}
                  >
                    <strong>{getValue(lead.leads?.[0]?.value || 0)}</strong>
                    <span>
                      Comissão:{" "}
                      {getValue(
                        (lead.leads?.[0]?.value * user.comission) / 100 || 0,
                      )}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Ver Detalhes">
                      <Button
                        shape="circle"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        styles={{
                          icon: {
                            height: 18,
                          },
                        }}
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          setLeadSelected(lead);
                          setIsOpenLead(true);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Editar">
                      <Button
                        shape="circle"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        styles={{
                          icon: {
                            height: 18,
                          },
                        }}
                        icon={<MdEdit size={18} />}
                        onClick={() => {
                          setId(lead.id);
                          setName(lead.name);
                          setEmail(lead.email);
                          setPhone_number(lead.phone_number);
                          setNecessity(lead.necessity);
                          setEmployees(lead.employees);
                          setLocation(lead.location);
                          setCnpj(lead.cnpj);
                          setObservation(lead.observation);
                          setIsOpen(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))}

              <Pagination
                style={{ margin: "30px 0", alignSelf: "center" }}
                current={page + 1}
                total={leadsTotal}
                pageSize={10}
                onChange={(p) => setPage(p - 1)}
              />
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
              }}
            >
              <MdPeopleOutline
                size={50}
                color="#ccc"
                style={{ marginBottom: 15 }}
              />
              <Message>
                Nenhum lead encontrado com os filtros aplicados.
              </Message>
            </div>
          )}
        </>
      ) : (
        <div
          style={{ display: "flex", justifyContent: "center", padding: 100 }}
        >
          <Spin size="large" color="#008037" />
        </div>
      )}

      {/* Modal Detalhado do Lead */}
      <Modal
        width={500}
        open={isOpenLead}
        onCancel={() => setIsOpenLead(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsOpenLead(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Detalhes do Lead
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>{leadSelected.name}</h2>

          <InfoTag>
            {leadSelected.email && (
              <div className="tag">
                <MdMail size={14} /> {leadSelected.email}
              </div>
            )}
            {leadSelected.phone_number && (
              <div className="tag">
                <MdPhone size={14} /> {leadSelected.phone_number}
              </div>
            )}
            {leadSelected.location && (
              <div className="tag">
                <MdLocationOn size={14} /> {leadSelected.location}
              </div>
            )}
            {leadSelected.cnpj && (
              <div className="tag">
                <MdBusiness size={14} /> CNPJ: {leadSelected.cnpj}
              </div>
            )}
            {leadSelected.employees && (
              <div className="tag">
                <MdGroup size={14} /> {leadSelected.employees} func.
              </div>
            )}
            {leadSelected.necessity && (
              <div className="tag">
                <MdAssignment size={14} /> {leadSelected.necessity}
              </div>
            )}
          </InfoTag>

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Observações do Cadastro:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {leadSelected.observation || "Sem observações adicionais."}
            </p>
          </div>

          <p
            style={{
              fontSize: 18,
              color: "#008037",
              fontWeight: "bold",
              margin: 0,
            }}
          >
            {getValue(leadSelected.leads?.[0]?.value || 0)}
          </p>
          <div
            style={{
              background: "#f9f9f9",
              padding: 15,
              borderRadius: 10,
              margin: "15px 0",
            }}
          >
            <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
              Valor da Comissão:
            </p>
            <p
              style={{
                fontSize: 20,
                color: "#008037",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              {getValue(
                leadSelected.leads?.[0]?.value * (user.comission / 100) || 0,
              )}
            </p>
          </div>

          <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
            {leadSelected.phone_number && (
              <FaWhatsapp
                size={22}
                color="#25D366"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${leadSelected.phone_number}`,
                  )
                }
              />
            )}
            {leadSelected.phone_number && (
              <MdPhone
                size={22}
                color="#333"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`tel:${leadSelected.phone_number}`)}
              />
            )}
            {leadSelected.email && (
              <MdMail
                size={22}
                color="#EA4335"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`mailto:${leadSelected.email}`)}
              />
            )}
          </div>

          <AssociateInfo>
            <img
              src={user.photo ? user?.photo_url : userPhoto}
              alt="Seu Perfil"
            />
            <div className="info">
              <span>Cadastrado por:</span>
              <strong>{user?.name} (Você)</strong>
            </div>
          </AssociateInfo>
          {leadSelected.leads?.[0]?.user && (
            <AssociateInfo>
              <img
                src={
                  leadSelected.leads?.[0].user.photo
                    ? leadSelected.leads?.[0].user.photo_url
                    : userPhoto
                }
                alt="Seu Perfil"
              />
              <div className="info">
                <span>Franqueado responsável:</span>
                <strong>{leadSelected.leads?.[0].user.name}</strong>
              </div>
            </AssociateInfo>
          )}
        </div>
      </Modal>

      {/* Modal de Cadastro/Edição */}
      <Modal
        title={id ? "Editar Lead" : "Cadastrando um novo lead"}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={handleSaveLead}
        onCancel={() => setIsOpen(false)}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          <ViewInput style={{ width: "48%" }}>
            <p>Nome Completo*</p>
            <Input
              placeholder="Nome do lead"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>E-mail*</p>
            <Input
              placeholder="email@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>Telefone/WhatsApp*</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"(00) 00000-0000"}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>Necessidade</p>
            <Input
              placeholder="Qual a necessidade?"
              value={necessity}
              onChange={(e) => setNecessity(e.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>Funcionários</p>
            <Input
              placeholder="Qtd funcionários"
              value={employees}
              onChange={(e) => setEmployees(e.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>Localização</p>
            <Input
              placeholder="Cidade/Estado"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "100%" }}>
            <p>CNPJ</p>
            <Input
              placeholder="00.000.000/0000-00"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "100%" }}>
            <p>Observações</p>
            <TextArea
              rows={4}
              placeholder="Alguma informação adicional importante?"
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
